module.exports = __webpack_public_path__ + "img/purchase-icon-dark.ba46c1aa.svg";